import React from 'react';
import { Grid, Container, Box } from '@mui/material';
import { BrowserView, MobileView } from 'src/hooks/useDevice';
import img_welcome from 'src/img/image_home.png';

const Welcome = () => {
    return (
        <Container>
            <BrowserView>
                <Grid container justifyContent="center">
                    <Grid item sx={{ padding: { xs: '1rem 1rem 3rem 1rem', md: '4rem 10rem 5rem 10rem' } }}>
                        <Box className="img_logo_welcome" >
                            <br />
                            <img
                                src={img_welcome}
                                alt="Bienvenida"
                                style={{ maxWidth: '80%',height: '20%' }}/>
                        </Box>
                    </Grid>
                </Grid>
            </BrowserView>
            <MobileView>
                <Box textAlign="center">
                    <img
                        src={img_welcome}
                        className="img_logo_welcome_mobile"
                        alt="Bienvenida"
                        style={{ maxWidth: '100%' }}
                    />
                </Box>
            </MobileView>
        </Container>
    );
};

export default Welcome;
